import { createContext, useContext } from "react";

export interface AuthUser {
  name: string;
  email: string;
}

export interface AuthContextValue {
  mode: "test" | "local";
  /** false until the boot-time SSO configuration is known. */
  ready: boolean;
  isAuthenticated: boolean;
  user: AuthUser | null;
  getToken: () => Promise<string | null>;
  /** "Sign in with Microsoft" (GoTrue Azure provider); undefined when SSO is off. */
  signIn: (() => Promise<void>) | undefined;
  /** Local email + password sign-in; rejects with an Error whose message is user-facing. */
  signInWithPassword: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
}
